import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext, AuthData } from '../../context/auth';
import { ClaimContext, ClaimData } from '../../context/claim';
import { PolicyContext, PolicyData } from '../../context/policy';
import DefaultDialog from '../DefaultDialog';

interface Props {
	authData: AuthData;
	claimData: ClaimData;
	policyData: PolicyData;
}

const AddSubclaimModal = (props: Props) => {
	const { claimData, policyData } = props;
	const { claimUpdateReq, claim } = claimData;
	const { policy } = policyData;
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = React.useState(false);
	const close = () => setIsOpen(false);
	const open = () => setIsOpen(true);

	const addSubclaim = () => {
		navigate(
			`/policy/${claim.policyLocator}/claims/${claim.locator}/addSubclaim`,
		);
	};

	const openModal = () => {
		// check if incident timestamp is within policy coverage
		// if not, display modal, otherwise go to subclaim page
		const incidentTimestamp =
			claimUpdateReq.incidentTimestamp || claim.incidentTimestamp;
		const { originalContractStartTimestamp, effectiveContractEndTimestamp } =
			policy;
		if (
			incidentTimestamp < originalContractStartTimestamp ||
			incidentTimestamp > effectiveContractEndTimestamp
		) {
			open();
		} else {
			addSubclaim();
		}
	};

	const renderContent = () => {
		return (
			<div>Cannot add subclaim. There is no coverage for this policy.</div>
		);
	};

	return (
		<>
			<Button
				key={'addSubclaim'}
				color='primary'
				variant='contained'
				onClick={openModal}
			>
				Add Subclaim
			</Button>
			<DefaultDialog
				actions={[{ text: 'Close', onClick: close }]}
				open={isOpen}
				onClose={close}
				title='Cannot add subclaim'
			>
				{renderContent()}
			</DefaultDialog>
		</>
	);
};

function withContext(Component: any) {
	return (props: Omit<Props, 'authData' | 'claimData' | 'policyData'>) => (
		<AuthContext.Consumer>
			{(authData) => (
				<ClaimContext.Consumer>
					{(claimData) => (
						<PolicyContext.Consumer>
							{(policyData) => (
								<Component
									{...props}
									authData={authData}
									claimData={claimData}
									policyData={policyData}
								/>
							)}
						</PolicyContext.Consumer>
					)}
				</ClaimContext.Consumer>
			)}
		</AuthContext.Consumer>
	);
}

export default withContext(AddSubclaimModal);
